"use client";

import React, { createContext, useState } from "react";

/** @typedef {import("@/TS/Interfaces/global_interfaces").BreadCrumbLink} BreadCrumbLink */

/** @type {React.Context<[BreadCrumbLink[], React.Dispatch<React.SetStateAction<BreadCrumbLink[]>>]>} */
export const breadcrumbContext = createContext(/** @type {any} */ (null));

/**
 * @param {{ children: import("react").ReactNode }} props
 */
function BreadcrumbContext({ children }) {
  const [value, setValue] = useState([{ href: "/", label: "Accueil" }]);

  return (
    <breadcrumbContext.Provider value={[value, setValue]}>
      {children}
    </breadcrumbContext.Provider>
  );
}

export default BreadcrumbContext;
